export const getHistoryUrl = (url) => `${url}/api/v1/Statistics/gameHistory`;

export function countOfIncrease(odd) {
  let step;
  let newOdd;
  const percent = 0.01;
  let count = 0;

  for (let i = percent; i < odd; i += percent) {
    step = odd * percent;
    newOdd = (newOdd || 1) + +step;
    count += 1;
    if (newOdd >= odd) {
      return count;
    }
  }
  return count;
}

export function resultSoundTimeOutHelper(odd) {
  if (odd <= 1.01) {
    return 0;
  }
  if (odd > 1.01 && odd <= 1.5) {
    return 550;
  }
  return 900;
}

export function increaseIntervalHelper(odd, isWin) {
  if (odd <= 1.5) {
    return 300;
  }
  if (odd > 1.5 && !isWin) {
    return 550;
  }
  if (odd > 1.5 && isWin) {
    return 450;
  }
  return 550;
}
